export const getStorageAllKeys = () => {
    const keys = Object.keys(localStorage);
    return keys;
};
